import React, { useState, useMemo } from 'react'
import { Icon, List, notification } from 'antd'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'

import { BudgetChartTicket, FullRequestVehicle, Request } from 'src/types'

import { ApplicationState } from 'src/store'
import { useStepsContext } from 'src/views/Requests/views/Form'
import useReasonPolicyRule from 'src/core/hooks/use-reason-policy-rule'

import ListItem from './list-item'
import SelectionModal from './selection-modal'

type Props = {
  onSubmit?(item: FullRequestVehicle): void
  request: Request
  loading?: boolean
  closeOnPick?: boolean
}

function SearchResultCardList({
  onSubmit,
  request,
  loading,
  closeOnPick = true
}: Props) {
  const { vehicles } = useSelector((state: ApplicationState) => ({
    vehicles: state.vehicles
  }))

  const [itemSelectionModal, setItemSelectionModal] =
    useState<FullRequestVehicle>()

  const stepsContext = useStepsContext()
  const { t } = useTranslation()

  const selectedVehicleUnique = useMemo(() => {
    const selecteds: string[] = []
    // if (request) {
    //   request.full_request_vehicle.forEach(requestvehicle => {
    //     requestvehicle.request_quote_vehicle_routes.forEach(route => {
    //       if (route.chosen) {
    //         route.request_quote_vehicles.forEach(vehicle => {
    //           if (vehicle.chosen) {
    //             selecteds.push(`${vehicle.request_quote_vehicle_hash}`)
    //           }
    //         })
    //       }
    //     })
    //   })
    // }
    return selecteds
  }, []) // request

  const policyRule = useReasonPolicyRule(
    request.request_user_data[0]?.reason_id
  )

  if (vehicles.loading) {
    return <></>
  }

  return (
    <>
      <List
        data-test-id="vehicle-result-list"
        dataSource={vehicles.list}
        itemLayout="vertical"
        locale={{
          emptyText: (
            <>
              <Icon
                type="info-circle"
                style={{ fontSize: 28, paddingBottom: 4 }}
              />
              <br />
              {t('web.services.vehicle.search-not-found')}
            </>
          )
        }}
        renderItem={(item, index) => {
          const isselected = selectedVehicleUnique.some(
            select => select === item.request_quote_vehicle_hash
          )
          return (
            <ListItem
              policyRule={policyRule}
              item={item}
              onSelect={selectedItem => {
                setItemSelectionModal(selectedItem)
              }}
              isselected={isselected}
            />
          )
        }}
      />
      <SelectionModal
        closeOnPick={closeOnPick}
        item={itemSelectionModal}
        loading={loading}
        onAdd={added => {
          if (onSubmit) {
            onSubmit(added)
            return
          }

          if (stepsContext.budgetChartAllocations.active) {
            const vehicleFareHash = added.request_quote_vehicle_unique

            const foundVehicleFare = vehicles.list.find(
              ({ request_quote_vehicle_unique }) =>
                vehicleFareHash.includes(request_quote_vehicle_unique)
            )

            const vehicleTickets: BudgetChartTicket[] = foundVehicleFare
              ? [
                  {
                    standard_type: 'VEHICLE',
                    total_value: foundVehicleFare.total_value
                  }
                ]
              : []

            stepsContext.setBudgetAllocations({
              standard_type: 'VEHICLE',
              tickets: vehicleTickets
            })
          }

          stepsContext.setRequest({
            ...request,
            full_request_vehicle: [
              {
                ...added
              }
            ]
          })

          notification.info({
            message: `${t('web.services.vehicle.title')} ${t(
              'common.actions.selected'
            )}`,
            placement: 'bottomRight'
          })
        }}
        request={request}
        toggle={() => setItemSelectionModal(null)}
        visible={!!itemSelectionModal}
      />
    </>
  )
}

export default SearchResultCardList
